export class ComponentMessages {
}

export const ProjectConstants = {
    SALESPLAN_TITLE: "Sales Plan",
    PROJECT_TITLE: "Project Intake",

    GENERALINFO_KEY_CATEGORY_REQUIRED: "Category is required",
    GENERALINFO_KEY_PROJECT_TITLE_REQUIRED: "Project Title is required",
    GENERALINFO_KEY_SRE_SPOC__REQUIRED: "ISO SPOC is required",

    // FUNDING_RMS_KEY_CATEGORY_CMF_PROMO_Required:'CMF PROMO is required',
    // FUNDING_RMS_KEY_CATEGORY_CMF_TACTIC_ID_Required:'TACTIC ID is required',
    FUNDING_RMS_KEY_CATEGORY_CMF_PROMO_TACTIC_ID_Required: 'CMF PROMO and TACTIC ID are required for Funding Type : CMF.',
    // FUNDING_RMS_KEY_CATEGORY_COST_Required:'Estimated Cost is required',
    // FUNDING_RMS_KEY_CATEGORY_EMAIL_Required:'Estimated Cost Confirmation email is required.',
    FUNDING_RMS_KEY_CATEGORY_EMAIL_Required: 'Confirmation email is required for Funding Type : Category.',
    // FUNDING_RMS_KEY_JTBD_Required:'SRE Reviewed and Approval email are required for Funding Type : JTBD',
    FUNDING_RMS_KEY_JTBD_Required: 'ISO Reviewed is required for Funding Type : JTBD',

    PRODUCT_KEY_SEARCH_PRODUCTS: "Select Category in order to search for products",
    PRODUCT_KEY_SELECTED_PRODUCT: "This product is already selected",

    SALESPLAN_DELETE_IMAGES: "Are you sure you want to delete the image?\n This action will permanently remove the image from the system",
    SALESPLAN_DELETE_HEADER: "Delete Image",
    SALESPLAN_DELETE_IMAGE_SUCCESS: "Image deleted successfully",
    VALIDATION_CRITERIA_DELETE_CONFIRM: "Are you sure you want to delete the criteria?\n This action will permanently remove the criteria from the system",
    VALIDATION_DELETE_CRITERIA_SUCCESS: "Criteria deleted successfully",
    CUSTOM_PRODUCT_KEY_SEARCH_PRODUCTS: "Select Category in order to search for products to add new product",
    VALIDATION_CRITERIA_DUPLICATE_SELECTION: "This criteria is already selected. Please choose a different one.",
    VALIDATION_REQUIRED_CRITERIATYPE: "Please Select Criteria Type",
    VALIDATION_REQUIRED_CRITERIA: "Please Select Criteria",
    VALIDATION_REQUIRED_CRITERIATEXT: "Please Enter Criteria",
    VALIDATION_CHANGE_CRITERIATEXT: "Please Change Criteria Text",
    VALIDATION_REQUIRED_RESPONSE: "Please Enter Response",
    VALIDATION_REQUIRED_RESPONSETYPE: "Please Select Response Type",
    VALIDATION_EDIT_NOCHANGES: "No Changes for Edit Action",

    VALIDATION_REMINDER_EMAIL: "You must create the project before sending a reminder email.",

    //VALIDATION_RESPONSES_REMOVE_CONFIRM: "Are you sure you want to remove the responses?\n This action will permanently remove the responses from the system",
    //VALIDATION_REMOVE_RESPONSE_SUCCESS: "Responses cleared successfully"

    NO_PRODUCTS_FOUND_ITEM_NUMBER: "No product found with the entered item number.",
    UPC_OR_DESCRIPTION_NOT_AVAILABLE:"UPC or Description not available",
    MAX_FIVE_QUESTIONS_ALLOWED: "A maximum of 5 audit questions is allowed",
    MAX_FIFTY_FIELDS_ARE_ALLOWED: "A maximum of 10 stocking priority fields is allowed.",
    MAX_TWO_IMG_ARE_ALLOWED: "maximum 2 images are allowed to upload perzzzzzzz",
    PLEASE_ENTER_BOTH_STORE_NUMBER_AND_TYPE : "Please enter both store number and type.",
    AT_LEAST_ONE_ADIT_QUESTION_REQUIRED : "•&nbsp;&nbsp;At least one audit question is required",
    AT_LEAST_ONE_STOCKING_PRIORITY_FIELD: "•&nbsp;&nbsp;At least one stocking priority field is required",
    AT_LEAST_ONE_STOCKING_PRIORITY_BRAND_FIELD: "•&nbsp;&nbsp;At least one stocking priority brand field is required",
    MAX_SEVEN_FIELDS_ARE_ALLOWED: "A maximum of 7 stocking priority brands is allowed.",
    PLEASE_FILL_MANDATORY_FIELDS : "Please fill mandatory fields",
    TITLE_MISSED: "Title  missed",
    TITLE_REQUIRED : "•&nbsp;&nbsp;Title is required",
    TYPE_OF_REQ_REQUIRED : "Type of Request is required",
    RES_OPTION_REQUIRED : "Response Option is required",
    DESCRIPTION_REQUIRED : "Description is required",
    ITEM_NUMBER_REQUIRED : "Item Number Required",
    BRAND_NAME_REQUIRED : "Brand Name Required",
    DATA_SAVED_SUCCESSFULLY : "Data saved successfully",
    MAX_FIFTY_NUMBERS_ALLOWS : "Maximum limit is 50 Numbers",
    ATLEAST_ONE_VALID_CATEGORY : "•&nbsp;&nbsp;At least one valid category is required",
    DATE_IS_REQUIRED : "•&nbsp;&nbsp;Date is required",
    TYPE_REQUIRED : "Type is Required",
    ALLOW_IMGS: "Allowing only images",

    SALESPLAN_SAVE_SUCCESS: "Sales Plan Saved Successfully",
    SALESPLAN_CLONE_SUCCESS: "Sales Plan Cloned Successfully",
    SALESPLAN_CLONE_EVENTTITLE_REQUIRED: "Please enter Event Title",

    STORE_NOTIFICATION_MSG: "Hawaii state store notification sent successfully.",
    STORE_VALIDATION_PENDING: "Store validation is pending. Please click 'Validate Stores' to continue before saving.",
    STORE_NOTIFICATION_PENDING: "Hawaii state store(s) are present in this project. Notification to ISO Admin is pending.",

    PROJECT_SALESPLAN_NOPROJECT: "Please save the project before notifying the ISO Admin."

}
